<template>
  <div>
    <div class="filter">
      <div class="filter-caption">
        <div class="school">状态</div>
        <div :class="{'filter-item':true, 'filter-item-active':condition.complete===null}"
             @click="filterState('all','complete')">全部
        </div>
      </div>
      <div class="filter-content">
        <div :class="{'filter-item':true, 'filter-item-active':condition.complete===0}"
             @click="filterState(0,'complete')">未分班
        </div>
        <div :class="{'filter-item':true, 'filter-item-active':condition.complete===1}"
             @click="filterState(1,'complete')">已分班
        </div>
      </div>
    </div>
    <div class="filter">
      <div class="filter-caption">
        <div class="school">班级</div>
        <div :class="{'filter-item':true, 'filter-item-active':crid===0}"
             @click="filterClassName(0)">重置
        </div>
      </div>
      <div class="filter-content">
        <div v-if="classNameList.length === 0"
             :class="{'filter-item':true, 'gray-color':true}">
          暂无开班数据
        </div>
        <div v-for="item in classNameList"
             :class="{'filter-item':true, 'filter-item-active':crid===item.id}"
             @click="filterClassName(item.id)">{{ item.crName }}
        </div>
      </div>
    </div>
    <div class="filter-year filter mb-20">
      <div class="filter-caption">
      </div>
      <div class="filter-content">
        <div v-for="item in years"
             :class="{'filter-year-item':true, 'filter-year-active':year===item}"
             @click="filterYear(item)">{{ item }}年
        </div>
      </div>
    </div>
    <el-form class="el-form-m20" :inline="true" size="small">
      <el-form-item class="search-bar">
        <el-input :class="{'w-30vw':normal,'w-100per':!normal}"
                  placeholder="请输入内容" v-model="searchValue">
          <el-select v-model="searchType" slot="prepend" placeholder="请选择">
            <el-option label="姓名" value="1"></el-option>
            <el-option label="学校" value="2"></el-option>
            <el-option label="院系" value="3"></el-option>
          </el-select>
          <el-button class="btn-search" @click="search" icon="el-icon-search" slot="append"></el-button>
        </el-input>
      </el-form-item>
      <el-form-item v-if="normal">
        <el-button-group>
          <el-button v-if="perm.indexOf('stu:allot') > -1" type="primary" icon="el-icon-set-up"
                     @click="dialogStudentVisible=true">分配班级
          </el-button>
          <!--<el-button type="primary" icon="el-icon-circle-plus-outline"
                     @click="createRow">新建班级
          </el-button>-->
          <el-button v-if="perm.indexOf('stu:delete') > -1" type="danger" icon="el-icon-delete"
                     @click="deleteSlt">批量删除
          </el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table
        ref="studentTable"
        :data="list"
        tooltip-effect="dark"
        style="width: 100%"
        row-key="openId"
        @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="45" :reserve-selection="true">
      </el-table-column>
      <el-table-column prop="openId" label="编号" width="100" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="name" label="姓名" width="100">
      </el-table-column>
      <el-table-column prop="mobile" label="手机号码" width="120" :formatter="formatMobile">
      </el-table-column>
      <el-table-column prop="gender" label="性别" width="50" :formatter="formatGender">
      </el-table-column>
      <!--<el-table-column prop="regTime" label="注册时间" :formatter="formatDate">
      </el-table-column>-->
      <el-table-column prop="school" label="学校">
      </el-table-column>
      <el-table-column prop="college" label="学院">
      </el-table-column>
      <!--<el-table-column prop="assistant" label="助教">
      </el-table-column>-->
      <el-table-column v-if="normal" label="操作">
        <template slot-scope="scope">
          <el-link v-if="perm.indexOf('stu:update') > -1"
                   type="primary"
                   icon="el-icon-edit"
                   @click="modifyRow(scope.$index, scope.row)">修改
          </el-link>
          <el-link v-if="scope.row.hasLearnRecord"
                   type="primary"
                   icon="el-icon-view"
                   @click="showLearnRecord(scope.$index, scope.row)">学习记录
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        :layout="normal ? 'sizes, prev, pager, next' : 'prev, pager, next'"
        :page-size="size"
        :total="total"
        :current-page.sync="index"
        @size-change="sizeChange"
        @current-change="currentChange">
    </el-pagination>
    <el-dialog v-if="normal && perm.indexOf('stu:update') > -1" @close="cancelForm" :title="title" width="40%"
               :visible.sync="dialogFormVisible"
               :lockScroll="false">
      <el-form ref="studentForm" :show-message="false" :model="form" label-position="right" label-width="80px">
        <el-form-item prop="name" label="姓名" :required="true">
          <el-input v-model="form.name" placeholder="请输入姓名" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="mobile" label="手机号" :required="true">
          <el-input :maxlength="11" v-model="form.mobile" placeholder="请输入手机号" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="gender" label="性别" :required="true">
          <el-radio-group v-model="form.gender">
            <el-radio-button :label="0">女</el-radio-button>
            <el-radio-button :label="1">男</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="school" label="学校" :required="true">
          <el-autocomplete
              style="width:100%"
              v-model="form.school"
              :fetch-suggestions="querySearch"
              placeholder="请输入或选择学校"
          ></el-autocomplete>
          <!--<el-input v-model="form.school" placeholder="请输入学校"
                    autocomplete="off"></el-input>-->
        </el-form-item>
        <el-form-item prop="college" label="学院" :required="true">
          <el-input v-model="form.college" placeholder="请输入学院"
                    autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelForm">取 消</el-button>
        <el-button type="primary" @click="confirmForm">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog v-if="normal && perm.indexOf('stu:allot') > -1" :visible.sync="dialogStudentVisible" @close="cs"
               @opened="$refs['classRoom'].getList()">
      <class-room ref="classRoom" :normal="false" @rowSelected="rowSelection"></class-room>
      <div slot="footer" class="dialog-footer">
        <el-button-group>
          <el-button size="small" @click="dialogStudentVisible=false">取 消</el-button>
          <el-button size="small" icon="el-icon-s-fold" @click="appendStudent">追加学生</el-button>
          <el-button size="small" icon="el-icon-setting" @click="resetStudent">重新分配班级
          </el-button>
        </el-button-group>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import helper from "../common/CZHelper";
import ClassRoom from "./ClassRoom";

export default {
  name: "Students",
  props: {
    normal: {
      type: Boolean,
      default: true
    }
  },
  components: {
    ClassRoom
  },
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL + "ma/student/",
      title: '',
      dialogFormVisible: false,
      dialogStudentVisible: false,
      selectionList: [],
      multipleSelection: [],
      condition: {
        school: null,
        name: null,
        college: null,
        complete: null
      },
      form: {
        school: null,
        name: null,
        gender: 1,
        college: null
      },
      year: new Date().getFullYear(),
      years: [],
      list: [],
      total: 0,
      size: this.normal ? 10 : 6,
      index: 1,
      school: [],
      classNameList: [],
      searchValue: "",
      searchType: "1",
      perm: localStorage.getItem('perm').split(","),
      crid: 0
    }
  },
  created() {
    /*
    能获得this，不会携带token
    this.getSchool();
    this.getClassName();
    this.getList();
    */
  },
  beforeRouteEnter(to, from, next) {
    //获取不了this，会携带请求头
    next(self => {
      self.initData();
      self.getSchool();
      self.getClassName();
      self.getList();
    });
  },
  methods: {
    initData() {
      this.years = [];
      for (let i = new Date().getFullYear(); i >= 2020; i--)
        this.years.push(i);
    },
    showLearnRecord(i, row) {
      this.$router.push({
        path: '/main/students/learnRecordCharts',
        query: {name: row.name, id: row.openId}
      });
    },
    formatGender(row, column, cellValue, index) {
      return cellValue === 0 ? '女' : '男';
    },
    formatMobile(row, column, cellValue, index) {
      if (this.perm.indexOf('ma:privacy') <= -1) {
        return cellValue.replace(cellValue.substr(3, 4), '****');
      }
      return cellValue;
    },
    cs() {
      this.selectionList = [];
      if (this.$refs['classRoom']) this.$refs['classRoom'].cs();
      this.$refs['studentTable'].clearSelection();
    },
    sizeChange(val) {
      this.size = val;
      this.getList();
    },
    currentChange(val) {
      this.index = val;
      this.getList();
    },
    querySearch(queryString, cb) {
      // 只能用{value:***}的对象数组才能看到结果，简单数组看不到结果
      let school = this.school.map((v, i) => {
        return {value: v}
      });
      let results = queryString ? school.filter(
          (item) => {
            return (item.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
          }
      ) : school;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    // table控件数据选中回调
    handleSelectionChange(val) {
      if (!this.normal) this.$emit("rowSelected", val);
      this.multipleSelection = val;
    },
    filterState(v, colName) {
      if (v === 'all')
        this.condition[colName] = null;
      else
        this.condition[colName] = v;
      this.index = 1;
      this.getList();
    },
    filterClassName(crid) {
      this.crid = crid;
      this.index = 1;
      this.getList();
    },
    filterYear(year) {
      this.year = year;
      this.getClassName();
      // this.getList();
    },
    // 自定义事件
    rowSelection(rows) {
      if (!rows.length) return;
      this.selectionList = rows;
    },
    deleteSlt() {
      this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        lockScroll: false
      }).then(() => {
        if (this.multipleSelection.length <= 0) return;
        let ids = [];
        this.multipleSelection.map((v, i) => ids.push(v.openId));
        this.$axios.post(
            this.apiUrl + "remove",
            {
              ids: ids.join(",")
            }
        ).then(response => {
          if (response.data.code === 200) {
            this.getList();
            this.cs();
          }
        });
      }).catch(() => {
        //    点击取消按钮的操作，没有会报错
      });
    },
    createRow() {
      this.show('添加学生');
    },
    modifyRow(rowIndex, row) {
      // 修改前创建副本
      this.form = JSON.parse(JSON.stringify(row));
      this.show('修改学生信息');
    },
    show(title) {
      this.dialogFormVisible = true;
      this.title = title;
      if (this.$refs['studentForm']) this.$refs['studentForm'].clearValidate();
    },
    cancelForm() {
      this.dialogFormVisible = false;
      this.form = {name: null, school: null, gender: 1, college: null};
    },
    confirmForm() {
      this.$refs['studentForm'].validate((valid) => {
        if (valid) {
          let postUrl = this.form.openId ? 'modify' : 'add';
          postUrl = this.apiUrl + postUrl;
          this.$axios.post(postUrl, this.form).then(response => {
            if (response.data.code === 200) {
              this.$message.success('操作成功');
              this.getList();
            } else {
              this.$message.error('操作失败');
            }
            this.cancelForm();
          });
        } else {
          return false;
        }
      });
    },
    getSchool() {
      this.$axios.post(
          process.env.VUE_APP_URL + 'ma/classroom/school'
      ).then(response => {
        this.school = response.data;
      });
    },
    getClassName() {
      this.$axios.post(
          process.env.VUE_APP_URL + `ma/classroom/className?year=${this.year}`
      ).then(response => {
        this.classNameList = response.data;
      });
    },
    // 追加课程
    appendStudent() {
      this.allotStudent("append");
    },
    resetStudent() {
      this.allotStudent("reset");
    },
    allotStudent(target) {
      if (this.multipleSelection.length <= 0) {
        this.$message.warning('请选择学生');
        return;
      }
      if (this.selectionList.length <= 0) {
        this.$message.warning('请选择班级');
        return;
      }
      if (this.selectionList.length !== 1) {
        this.$message.warning('只能选择一个班级');
        return;
      }
      let studentIds = this.multipleSelection.map(item => item.openId);
      let classRoomIds = this.selectionList.map(item => item.id);
      this.$axios.post(
          this.apiUrl + target,
          {
            stuIds: studentIds.join(","),
            crIds: classRoomIds.join(",")
          }
      ).then(response => {
        if (response.data.code === 200) {
          this.$message.success('分配班级成功');
          this.cs();
          this.getList();
        } else {
          this.$message.error('分配班级失败');
        }
        this.dialogStudentVisible = false;
      });
    },
    search() {
      this.index = 1;
      this.condition.name = this.condition.school = this.condition.college = null;
      switch (this.searchType) {
        case "1":
          this.condition.name = this.searchValue;
          break;
        case "2":
          this.condition.school = this.searchValue;
          break;
        case "3":
          this.condition.college = this.searchValue;
          break;
      }
      this.getList();
    },
    getList() {
      let params = {
        index: this.index,
        size: this.size,
        crid: this.crid,
        student: JSON.stringify(this.condition)
      };
      helper.getList(this.apiUrl + 'list', params, this);
    }
  }
}
</script>

<style scoped>
@import "../css/common.css";

.el-select {
  width: 80px;
}

.el-tag {
  margin: 0 8px;
}

.el-tag-first {
  margin-left: 0;
}

.el-table th, .el-table td {
  padding: 5px 0;
}


.el-link {
  margin: 0 5px;
}

.el-form-m20 {
  margin: 0 10px;
  /*text-align: right;*/
}

.school {
  color: #9f9f9f;
  width: 78px;
}

.filter {
  display: flex;
  color: #e79b37;
  padding: 10px 0 10px 25px;
  font-size: 0.9em;
  background: white;
  border-radius: 4px;
}

.filter-year {
  padding: 0 0 10px 25px;
}

.filter-content {
  display: flex;
  flex-wrap: wrap;
}

.filter-caption {
  display: flex;
  min-width: 130px;
}

.mb-20 {
  margin-bottom: 20px;
}

.filter-item-active {
  color: #8b0000;
}

.filter-year-item {
  margin: 0 10px;
  cursor: pointer;
  color: #c0c0c0;
}

.filter-year-active {
  color: gray;
  border-bottom: 1px solid gray;
}

.filter-item {
  margin: 0 10px;
  cursor: pointer;
}

.gray-color {
  color: gray;
}

</style>